import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-mall-product',
    templateUrl: './common-mall-product.component.html',
    styleUrls: ['./common-mall-product.component.scss'],
    standalone: false
})
export class CommonMallProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
